module.exports = __webpack_public_path__ + "media/images/smart_phone/menus/201809/top_images/2-2-569dfe6a59ce2d443d03d3642f869d9d.png";